module.exports = __webpack_public_path__ + "static/media/empty-list.9f81349c.svg";